var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"spinner-container"},[_c('svg',{staticClass:"spinner",attrs:{"width":"44px","height":"44px","viewBox":"0 0 44 44"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"4","stroke-linecap":"round","cx":"22","cy":"22","r":"20"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }